import { render, staticRenderFns } from "./InvitacionesEventosList.vue?vue&type=template&id=5d1e85e0"
import script from "./InvitacionesEventosList.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesEventosList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports